import React from "react";
import { Modal, ListGroup, Button } from "react-bootstrap";
import Socials from "../socials/Socials";

const ContactModal = props => {
  return (
    <Modal show={props.showContact} onHide={props.toggleContact} centered>
      <Modal.Header closeButton>
        <Modal.Title>Contact Info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup.Item>Yixuan Zhou</ListGroup.Item>
        <ListGroup.Item>zyxbbt@gmail.com</ListGroup.Item>
        <ListGroup.Item>183-xxxx-1747</ListGroup.Item>
        <ListGroup.Item>Shenzhen, Guangdong</ListGroup.Item>
        <ListGroup.Item>
          <Socials />
        </ListGroup.Item>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.toggleContact}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContactModal;
